import React from 'react';

const NotificationBadge = ({ 
  count = 0, 
  max = 99,
  size = 'default',
  variant = 'accent',
  className = ''
}) => {
  if (count <= 0) return null;

  const displayCount = count > max ? `${max}+` : count;

  const sizeClasses = {
    sm: 'h-4 w-4 text-[9px]',
    default: 'h-5 w-5 text-[10px]',
    lg: 'h-6 w-6 text-xs'
  };

  const variantClasses = {
    accent: 'bg-accent text-accent-foreground',
    success: 'bg-success text-success-foreground',
    warning: 'bg-warning text-warning-foreground',
    error: 'bg-error text-error-foreground'
  };

  return (
    <span 
      className={`
        inline-flex items-center justify-center rounded-full
        font-bold data-text
        ${sizeClasses?.[size]}
        ${variantClasses?.[variant]}
        ${className}
      `}
      aria-label={`${count} notification${count !== 1 ? 's' : ''}`}
    >
      {displayCount}
    </span>
  );
};

export default NotificationBadge;